module.exports = __webpack_public_path__ + "static/media/button@2x.a4be112e.png";